module.exports = __webpack_public_path__ + "media/images/dividend/il-coupontheme-memorial-left-9ccb03010a0124aa0297e78399924e1b.svg";